<siq-js-date-picker
  *ngIf="config?.primaryDate"
  [config]="config.primaryDate"
  [initModel]="initModel"
  [disableInitModelValidation]="disableInitModelValidation"
  [noDefault]="noDefault"
  (dateChanged)="onDateSelected($event)"
  (wEndingChanged)="onWEndingChanged($event)"
></siq-js-date-picker>